<template>
    <div class="modal-panel">
        <div class="menu">
            <div class="position-relative">
                <div class="d-flex cookies-panel">
                    <div class="content-text">
                        <span class="text-bold">Mergerfilers.com provides a well-explained merger control guide and decision database. </span>
                        <span class="text">It is all 100% free as the content is sponsored by some of the world's top law firms.</span>
                    </div>
                    <div class="d-flex justify-space-between right-content">
                        <div class="d-flex flex-column form-content">
                            <div class="form-text">To fully access those features, I accept:</div>
                            <div class="form-checkboxs">
                                <div class="form-check">
                                    <div class="cookies-form-check-input-outer" :class="data.cookies ? 'cookies-guide-checkbox-selected' : ''" >
                                        <input class="cookies-form-check-input" type="checkbox"
                                                v-model="data.cookies"
                                                id="cookies">
                                    </div>
                                    <label class="form-check-text" for="cookies">
                                        Necessary cookies
                                    </label>
                                </div>
                                <div class="form-check">
                                    <div class="cookies-form-check-input-outer" :class="data.terms ? 'cookies-guide-checkbox-selected' : ''" >
                                        <input class="cookies-form-check-input" type="checkbox"
                                                v-model="data.terms">
                                    </div>
                                    <label class="form-check-text form-text-terms" @click="showTerms">
                                        Terms of Use
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center">
                        <button type="button" class="btnstyle cookies-button align-items-center" @click="continueHandler">
                            <div class="button-text">Continue</div>

                            <span class="material-symbols-outlined material-symbols-outlined-400 arrow-icon"
                            >arrow_forward</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {ref} from 'vue'

import {useMainStore} from "@/stores/mainStore";

const data = ref<any>({terms: false, cookies: false})

const mainStore = useMainStore();

function showTerms() {
    mainStore.showTerms(true)
}

function continueHandler() {
    if (!data.value.cookies || !data.value.terms) {
        mainStore.showAlert({
            title: 'Error!',
            type: 'error',
            message: 'You must accept cookies and terms!',
        })
        return
    }
    localStorage.setItem('cookies-accepted', 'true')
    mainStore.showCookies(false)
}

</script>

<style scoped lang="scss">
.modal-panel {
    position: absolute;
    top: 0;
}

.cookies-panel {
    width: 90vw;
    gap: 64px;
    border-radius: 2000px;
    padding: 24px 32px;
    background:  rgba(248, 250, 255, 1);
    box-shadow: 0px 0px 12px 3px rgba(221, 110, 31, 1);
    @media (min-width: $max-xl-screen) {
        gap: 72px;
        border-radius: 2000px;
        padding: 32px 48px;
        box-shadow: 0px 0px 16.57px 4.14px rgba(221, 110, 31, 1);
    }
    @media (max-width: $max-md-screen) {
        flex-direction: column;
        width: 80vw;
        gap: 36px;
        border-radius: 20px;
        padding: 24px;
        box-shadow: 0px 0px 12px 4px rgba(221, 110, 31, 1);
    }
    @media (max-width: $max-sm-screen) {
        width: 85vw;
        gap: 32px;
        border-radius: 20px;
        padding: 32px;
        box-shadow: 0px 0px 12px 4px rgba(221, 110, 31, 1);
    }
}

.menu {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 2;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    bottom: 60px;
    @media (max-width: $max-md-screen) {
        align-items: center;
        bottom: unset;
    }
}

.content-text {
    width: 62%;
    align-content: center;
    @media (max-width: $max-md-screen) {
        width: 100%;
    }
}

.right-content {
    width: 38%;
    @media (max-width: $max-md-screen) {
        width: 100%;
    }
}

.form-content {
    gap: 12px;
    @media (min-width: $max-xl-screen) {
        gap: 22.09px;
    }
    @media (max-width: $max-md-screen) {
        gap: 16px;
    }
    @media (max-width: $max-sm-screen) {
        gap: 18px;
        padding-left: 2px;
        padding-right: 2px;
    }
}

.text,
.text-bold {
    font-family: Raleway;
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
    color: rgba(0, 0, 0, 1);
    @media (min-width: $max-xl-screen) {
        font-size: 24px;
    }
    @media (max-width: $max-md-screen) {
        font-size: 18px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 16px;
    }
}
.text-bold {
    font-weight: 700;
}

.form-text,
.form-check-text,
.form-text-terms,
.form-check-label {
    font-family: Raleway;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    color: rgba(0, 0, 0, 1);
    @media (min-width: $max-xl-screen) {
        font-size: 18px;
    }
    @media (max-width: $max-md-screen) {
        font-size: 14px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 14px;
    }
}

.form-check-text {
    font-weight: 500;
}
.form-text-terms {
    color: rgba(221, 110, 31, 1);
    text-decoration: underline;
}

.form-check-label {
    color:  rgba(24, 24, 24, 1);
}

.cookies-form-check-input-outer {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    border: 1px solid rgba(221, 110, 31, 1);
    background-color: transparent;
    width: 18px;
    height: 18px;
    box-shadow: 2px 2px 5px 0 rgba(0, 56, 159, 0.25), -2px -2px 2px 0 rgba(255, 255, 255, 1);
    @media (min-width: $max-xl-screen) {
        width: 27px;
        height: 27px;
        border-radius: 2.76px;
        border-width: 1.38px;
        box-shadow: 2.76px 2.76px 6.9px 0px rgba(0, 56, 159, 0.25), -2.76px -2.76px 2.76px 0px rgba(255, 255, 255, 1);
    }   
    @media (max-width: $max-md-screen) {
        width: 20px;
        height: 20px;
        border-radius: 2px;
        border-width: 1px;
        box-shadow: 2px 2px 5px 0px rgba(0, 56, 159, 0.25), -2px -2px 2px 0px rgba(255, 255, 255, 1);
    }
    @media (max-width: $max-sm-screen) {
        width: 17.5px;
        height: 17.5px;
        border-radius: 1.75px;
        border-width: 0.88px;
        box-shadow: 1.75px 1.75px 4.38px 0px rgba(0, 56, 159, 0.25), -1.75px -1.75px 1.75px 0px rgba(255, 255, 255, 1);
    }
}

.cookies-form-check-input {
    border-radius: 2px;
    background-color: rgba(248, 250, 255, 1);
    margin-top: 0;
    width: 16px;
    height: 16px;
    appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
    position: relative;
    @media (min-width: $max-xl-screen) {
        width: 22px;
        height: 22px;
    }
    @media (max-width: $max-md-screen) {
        width: 18px;
        height: 18px;
    }
    @media (max-width: $max-sm-screen) {
        width: 15.5px;
        height: 15.5px;
    }
}

.cookies-form-check-input:checked {
    background-color: rgba(221, 110, 31, 1);
    top: 0.25px;
    @media (max-width: $max-md-screen) {
        left: 0.25px;
    }
    @media (max-width: $max-sm-screen) {
        left: 0.25px;
    }
}
.cookies-form-check-input:checked::after {
    content: '';
    position: absolute;
    top: 3px;
    left: 6px;
    width: 4px;
    height: 8px;

    border: solid rgba(248, 250, 255, 1);
    border-width: 0 1.5px 2px 0;
    transform: rotate(45deg);

    @media (min-width: $max-xl-screen) {
        top: 4px;
        left: 8px;
        width: 5px;
        height: 10px;
    }
    @media (max-width: $max-md-screen) {
        top: 3.5px;
        left: 7px;
        width: 4px;
        height: 8px;
        border-width: 0 1px 1.5px 0;
    }
    @media (max-width: $max-sm-screen) {
        top: 3px;
        left: 6px;
        width: 3px;
        height: 7px;
        border-width: 0 1px 1.5px 0;
    }
}

.form-check {
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 0;
    @media (min-width: $max-xl-screen) {
        gap: 20.71px;
    }
    @media (max-width: $max-md-screen) {
        gap: 15px;
    }
    @media (max-width: $max-sm-screen) {
        gap: 24px;
    }
}

.cookies-button {
    display: flex;
    gap: 5px;
    padding: 16px;
    border-radius: 40px;
    background: radial-gradient(102.04% 337.36% at 0% 0%, #DD6E1F 34.45%, #D74D46 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
    box-shadow: 4px 4px 2px 0px rgba(0, 47, 164, 0.25), -1px -1px 1px 0px rgba(210, 213, 255, 1);
    @media (min-width: $max-xl-screen) {
        gap: 8px;
        padding: 24px;
        border-radius: 2000px;
        box-shadow: 5.52px 5.52px 2.76px 0px rgba(0, 47, 164, 0.25), -1.38px -1.38px 1.38px 0px rgba(210, 213, 255, 1);
    }
    @media (max-width: $max-md-screen) {
        width: 100%;
        justify-content: space-between;
        padding: 8px 12px;
        border-radius: 2000px;
        box-shadow: 1.82px 1.82px 1.82px 0px rgba(0, 0, 0, 0.25), -1.82px -1.82px 1.82px 0px rgba(255, 255, 255, 0.2);
    }
    @media (max-width: $max-sm-screen) {
        padding: 8px 12px;
        box-shadow: 1.82px 1.82px 1.82px 0px rgba(0, 0, 0, 0.25), -1.82px -1.82px 1.82px 0px rgba(255, 255, 255, 0.2);
    }
}

.button-text {
    font-family: Raleway;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: center;
    color:  rgba(248, 250, 255, 1);
    @media (min-width: $max-xl-screen) {
        font-size: 24px;
    }
    @media (max-width: $max-md-screen) {
        font-size: 14px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 14px;
    }
}
.arrow-icon {
    font-size: 24px;
    color:  rgba(248, 250, 255, 1);
    @media (min-width: $max-xl-screen) {
        font-size: 28px;
    }
    @media (max-width: $max-md-screen) {
        font-size: 16.92px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 14.31px;
    }
}

.form-checkboxs {
    display: flex;
    flex-direction: column;
    gap: 8px;
    @media (min-width: $max-xl-screen) {
        gap: 16.57px;
    }
    @media (max-width: $max-md-screen) {
        gap: 12px;
    }
    @media (max-width: $max-sm-screen) {
        gap: 24px;
    }
}
</style>
